import React from "react";
import { object } from "prop-types";
import { Link } from "@quintype/components";

import Headline from "../../atoms/headline";
import AuthorsView from "../../atoms/authors-view";

import { getHeadline, isAuthorNameShown, getStoryLine } from "../../utils/utils";

import "./customStoryCard2.m.css";

const CustomStoryCard2 = ({ story }) => {
  const headline = getHeadline(story);
  const storyLine = getStoryLine(story);

  return (
    <div styleName="wrapper" className="custom-story-card-2">
      {storyLine ? storyLine !== "" && <div className="title">{storyLine}</div> : <></>}
      <Link href={story.url}>
        <Headline text={headline} headerType={2} headerLevel={2} story={story} />
      </Link>
      {isAuthorNameShown(story) && (
        <div styleName="author-name">
          <AuthorsView story={story} />
        </div>
      )}
    </div>
  );
};

CustomStoryCard2.propTypes = {
  story: object.isRequired,
};

export default CustomStoryCard2;
